import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const LOGYARDTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.LogyardType.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
];

export const LOGYARDTYPE_CONFIG = {
  entityName: 'LogyardType',
  localizationKey: 'Planning::Entity.LogyardType',
  fields: LOGYARDTYPE_FIELDS,
  permission: 'PlanningLocation.LogyardTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
